module.exports = require("core-js/library/fn/object/values");


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/@babel/runtime/core-js/object/values.js
// module id = 41
// module chunks = 35783957827783 114276838955818